//# Global imports
import variableColors from "./_App.module.scss";

//# Agency Imports
//* -----------------------
//- Polish Agencies Configs
//* -----------------------
//^  01_PKS (1211)
//* Imports
// import logoPKS from "./assets/logo/logoPKS.png";
// import { treeGroupsDataPKS } from "./data/groups";
// //* Eksports
// export const configAgencyName = "PoznanPKS";
// export const logo = logoPKS;
// export const treeGroupsData = treeGroupsDataPKS;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = ["00_#", "02_Linia", "12_Pojazd", "13_Status", "14_Postęp"];
// //* Api prefix
// export const apiPrefix = "https://api-dyspozytor.pksonline.pl/api"; //! api TC2.0 - prod
// // export const apiPrefix = "https://api-dyspozytor2.pksonline.pl/api"; //! api TC1.0 - dev
// // export const apiPrefix = "http://goeuropa.net:8093/api"; //- Test API
// // export const apiPrefix = "https://pks.goeuropa.net/api"; //+ Test api - api TC2.0 working stats charts!
// export const apiPrefixWeb = ""; //+ apiWeb, or: "https://api-dyspozytor.pksonline.pl"  -----------------> getBaseStatsUrl
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false; //! showReverseGeocoding
// // Name app
// export const appName =
//   apiPrefix === ("https://api-dyspozytor.pksonline.pl/api" as string)
//     ? "PKS Online Dyspozytornia 2.0"
//     : "PKS Online Archiwum";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 2 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true; //! disableButtons
// export const disableSettingsButton = true; //! disableSettingsButtons
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 3;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = false; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = false;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = {
//   api: process.env.REACT_APP_PKS_TRACCAR_API,
//   credentials: [
//     {
//       username: process.env.REACT_APP_PKS_TRACCAR_LOGIN_SLUZ,
//       password: process.env.REACT_APP_PKS_TRACCAR_PASSWORD_SLUZ,
//     },
//     {
//       username: process.env.REACT_APP_PKS_TRACCAR_LOGIN_POM,
//       password: process.env.REACT_APP_PKS_TRACCAR_PASSWORD_POM,
//     },
//   ],
// };
// //* ServiceAlerts
// const alertsUrl = "https://alerts.pksonline.pl/api";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = process.env.NODE_ENV === "development" ? false : true;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = true; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost =
//   apiPrefix === ("https://api-dyspozytor.pksonline.pl/api" as string)
//     ? "https://pksonline.pl/download/raporty/"
//     : "https://pksonline.pl/download/raporty2/"; //^ 30-day stops report target url (raporty2)

//^ 02_Kombus Kórnik (20/200)
//* Imports
// import logoKombusKornik from "./assets/logo/logoKombusKornik.png";
// import { treeGroupsDataKombusKornik } from "./data/groups";
// //* Eksports
// export const configAgencyName = "kombusKornik";
// export const logo = logoKombusKornik;
// export const treeGroupsData = treeGroupsDataKombusKornik;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tckombus.iplaner.pl/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false;
// // Name app
// export const appName = "KiedyBus Kórnik";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = false;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "https://alerts.iplaner.pl/api";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 03_Środa Wlkp (333)
//* Imports
// import logoSroda from "./assets/logo/logoSroda.png";
// import { treeGroupsDataSrodaWlkp } from "./data/groups";
// //* Eksports
// export const configAgencyName = "kombusSroda";
// export const logo = logoSroda;
// export const treeGroupsData = treeGroupsDataSrodaWlkp;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcsroda.iplaner.pl/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false;
// // Name app
// export const appName = "KiedyBus - Środa Wlkp";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = false;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "https://alerts.iplaner.pl/api";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 04_Kombus ZTM (22/4)
//* Imports
// import logoKombusZTM from "./assets/logo/logoKombusZTM.png";
// import { treeGroupsKombusZTM } from "./data/groups";
// //* Eksports
// export const configAgencyName = "kombusZTM";
// export const logo = logoKombusZTM;
// export const treeGroupsData = treeGroupsKombusZTM;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcztmkombus.iplaner.pl/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false;
// // Name app
// export const appName = "KiedyBus ZTM Kombus";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = false;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "https://alerts.iplaner.pl/api";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 05_Rokbus (8)
//* Imports
// import logoRokbus from "./assets/logo/Rokbus.svg";
// import { treeRokbus } from "./data/groups";
// //* Eksports
// export const configAgencyName = "Rokbus";
// export const logo = logoRokbus;
// export const treeGroupsData = treeRokbus;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcrokbus.iplaner.pl/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false;
// // Name app
// export const appName = "KiedyBus Rokbus";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = true;
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = false; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "https://alerts.iplaner.pl/api";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//- TA Configs
//* -----------------------
//^ 06_TA Miami-Dade (33132)
//* Imports
// import logoMiamiDate from "./assets/logo/logoMiamiDade.png";
// import { treeGroupsDataTA_MDT } from "./data/groups";
// //* Eksports
// export const configAgencyName = "MiamiDade";
// export const logo = logoMiamiDate;
// export const treeGroupsData = treeGroupsDataTA_MDT;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcmdt.tracktrolley.com/api";
// // export const apiPrefix = "http://goeuropa.net:8091/api"; //* Test api
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Miami-Dade TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = false;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "MDT";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// //* url: https://tcmdt.tracktrolley.com/api/v1/key/f78a2e9a/agency/33132/command/gtfs-rt/vehiclePositions
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 07_TA City of Miami Beach (2362)
//* Imports
// import logoMiamiBeach from "./assets/logo/MiamiBeach.png";
// import { treeGroupsDataTA_COMB } from "./data/groups";
// //* Eksports
// export const configAgencyName = "MiamiBeach";
// export const logo = logoMiamiBeach;
// export const treeGroupsData = treeGroupsDataTA_COMB;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tccomb.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Miami Beach TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = false;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "MIAMI BEACH";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 08_TA SweetWater (33174)
//* Imports
// import logoSweetWater from "./assets/logo/SweetWater.png";
// import { treeGroupsDataTA_SW } from "./data/groups";
// //* Eksports
// export const configAgencyName = "SweetWater";
// export const logo = logoSweetWater;
// export const treeGroupsData = treeGroupsDataTA_SW;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcsw.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Sweetwater TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "SWEETWATER";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 09_TA Doral (13)
//* Imports
// import logoDoral from "./assets/logo/Doral.png";
// import { treeGroupsDataTA_Doral } from "./data/groups";
// //* Eksports
// export const configAgencyName = "Doral";
// export const logo = logoDoral;
// export const treeGroupsData = treeGroupsDataTA_Doral;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcdt.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Doral TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "DORAL";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 10_TA Miami Springs (MS)
//* Imports
import sealMiamiSprings from "./assets/logo/MiamiSprings.png";
import { treeGroupsDataTA_MiamiSprings } from "./data/groups";
//* Eksports
export const configAgencyName = "MiamiSprings";
export const logo = sealMiamiSprings;
export const treeGroupsData = treeGroupsDataTA_MiamiSprings;
export const apiKey = "f78a2e9a";
export const initialTableBigComponentColumns = [
  "00_#",
  "01_Zmiana",
  "02_Linia",
  "03_Zadanie",
  "12_Pojazd",
  "13_Status",
  "14_Postęp",
  "23_Akcje",
];
//* Api prefix
export const apiPrefix = "/api";
export const apiPrefixWeb = ""; //+ apiWeb
//* Reverse GeoCoding
export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
export const showReverseGeocoding = true;
// Name app
export const appName = "Track Trolley Miami Springs TC";
// Fetch interval
export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// Bus toleration settings
const tooFastToleration = 60 * 1 * 1000; //* [ms]
const delayToleration = -60 * 3 * 1000; //* [ms]
// Map setting
export const zoomRange = 0.01;
export const busZoom = 11.5;
export const positionZoom = 18;
export const positionAccuracy = 4;
export const defaultTabKey = "blok";
//* Disable buttons and Header info
export const disableButtons = true;
export const disableSettingsButton = false;
export const contentOnlyForTA = true;
export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// TripsReport
export const showFullTable = true;
// Table width
export const initialTableWidth = 4;
// Fetching vehiclesToBlock
export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// vehiclesDetails
export const useLongVehicleDetails = true;
export const traccarApiKnotsToKmh = 1.852;
// i18next settings
export const defaultLanguage = "en";
export const showChangeLanguage = false;
//* TA only!
export const comparisonApisVar: string | string[] = ["MIAMI SPRINGS"];
//* Traccar Api!
export const traccarCredentials = null;
//* ServiceAlerts
const alertsUrl = "";
//* Other settings
export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
export const startFromAccordion: boolean = false;
export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
export const downloadableStopsData: boolean = false; //* 30-day report for all stops
export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 11_TA Small-Cities (33186)
//* Imports
// import logoLSF from "./assets/logo/LSF_ShuttleLogo.png";
// import { treeGroupsDataTA_SmallCities } from "./data/groups";
// //* Eksports
// export const configAgencyName = "SmallCities";
// export const logo = logoLSF;
// export const treeGroupsData = treeGroupsDataTA_SmallCities;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcsc.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Small Cities TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = [
//   "LAUDERHILL",
//   "MARGATE",
//   "DANIA BEACH",
//   "HILLSBORO BEACH",
//   "NORTH LAUDERDALE",
//   "POMPANO BEACH",
//   "HOLLYWOOD",
//   "LAUD LAKES",
// ];
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 12_Fort Lauderdale (33311)
//* Imports
// import logoFortLauderdale from "./assets/logo/logoFortLauderdale.png";
// import { treeGroupsDataTA_FortLauderdale } from "./data/groups";
// //* Eksports
// export const configAgencyName = "FortLauderdale";
// export const logo = logoFortLauderdale;
// export const treeGroupsData = treeGroupsDataTA_FortLauderdale;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcfll.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Fort Lauderdale TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "LAUDERGO";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 13_TA Pompano Beach (PB)
//* Imports
// import logoPompanoBeach from "./assets/logo/logoPompanoBeach.png";
// import { treeGroupsDataTA_PompanoBeach } from "./data/groups";
// //* Eksports
// export const configAgencyName = "PompanoBeach";
// export const logo = logoPompanoBeach;
// export const treeGroupsData = treeGroupsDataTA_PompanoBeach;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcpb.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley Pompano Beach TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = false;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "POMPANO BEACH";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//^ 14_Broward County Transit (BCT)
//* Imports
// import logoBCT from "./assets/logo/BCT.png";
// import { treeGroupsDataTA_BCT } from "./data/groups";
// //* Eksports
// export const configAgencyName = "BCT";
// export const logo = logoBCT;
// export const treeGroupsData = treeGroupsDataTA_BCT;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcbct.tracktrolley.com/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.tracktrolley.com";
// export const showReverseGeocoding = true;
// // Name app
// export const appName = "Track Trolley BCT TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 5 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = true;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "en";
// export const showChangeLanguage = false;
// //* TA only!
// export const comparisonApisVar: string | string[] = "BCT";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url

//@ ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//^ 00_TEST API (???)
//* Imports
// import logoGoEuropa from "./assets/logo/logoGoEuropa.png";
// import { treeKiedyBusDyspozytor } from "./data/groups";
// //* Eksports
// export const configAgencyName = "KiedyBusDyspozytor";
// export const logo = logoGoEuropa;
// export const treeGroupsData = treeKiedyBusDyspozytor;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcbus.iplaner.pl/api";
// export const apiPrefixWeb = ""; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false;
// // Name app
// export const appName = "KiedyBus Dyspozytor";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.01;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "blok";
// //* Disable buttons and Header info
// export const disableButtons = true;
// export const disableSettingsButton = true;
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = false; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.852;
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "https://alerts.iplaner.pl/api";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false; //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url
//@ ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

//@ Common settings
export const newSplitCharactersSet: string = "~|~";
export const numberOfYearsBeforeForDatePicker: number = 4;
export const statuteMile: number = 1.60934;
export const allStopsReportDaysNumbers: number = 31;

//@ Common settings - Route
export const showRouteProfile: boolean = process.env.NODE_ENV === "development" ? true : false;

//@ Common settings - TA
//* Post Api
export const apiPrefixTaSchedule = process.env.REACT_APP_TA_scheduleApi;
export const credentialsData = {
  grant_type: "client_credentials",
  client_id: process.env.REACT_APP_TA_client_id,
  client_secret: process.env.REACT_APP_TA_client_secret,
  scope: "*",
};
export const axiosHeaders = {
  "content-type": "application/json",
  accept: "application/json",
};

//@ Breakpoints
const { fullHDresolution } = variableColors;
// console.log({ fullHDresolution }, typeof fullHDresolution);

const breakpoints = {
  fullHD: fullHDresolution,
};

export const devices = {
  fullHD: `(max-width: ${breakpoints.fullHD})`,
};

//# Common settings Service Alerts Manager
export const alertsLanguage = "en";
export const alertsBaseUrl = alertsUrl || "https://alerts.goeuropa.net/api";
// console.log("alertsBaseUrl:", alertsBaseUrl);
const authHeaderString = "user:goeuropa"; //* Alert header Authorization string
const authorizationHeader = window.btoa(authHeaderString);
// console.log({ authorizationHeader });
export const alertHeaders = {
  Authorization: `Basic ${authorizationHeader}`,
  "content-type": "application/json",
  "Accept-Language": "en-US",
};

//^ MapAllRoutes
export const circleRadius = 500; //* [m]

//^ Toleration
export const allowableLate: number = delayToleration / (60 * 1000); //* [min]
export const allowableEarly: number = tooFastToleration / (60 * 1000); //* [min]

//# Map MaxBounds based on api
const apisPL = [
  "http://goeuropa.net:8093/api",
  "https://api-dyspozytor2.pksonline.pl",
  "https://tckombus.iplaner.pl/api",
  "https://tcsroda.iplaner.pl/api",
  "https://tcztmkombus.iplaner.pl/api",
  "https://tcspk.iplaner.pl/api",
  "https://api-dyspozytor.pksonline.pl/api",
  "https://pks.goeuropa.net/api",
  "https://tcrokbus.iplaner.pl/api",
  "https://tcbus.iplaner.pl/api",
];
const apisFL = [
  "https://tcmdt.tracktrolley.com/api",
  "https://tccomb.tracktrolley.com/api",
  "https://tcsw.tracktrolley.com/api",
  "https://tcdt.tracktrolley.com/api",
  "https://tcsc.tracktrolley.com/api",
  "https://tcfll.tracktrolley.com/api",
  "https://tcms.tracktrolley.com/api",
  "https://tcpb.tracktrolley.com/api",
  "https://tcbct.tracktrolley.com/api",
];

const maxBoundsPL: number[][] = [
  [49.0, 14.1],
  [54.8, 24.1],
];

const maxBoundsFL: number[][] = [
  [24.0, -82.5],
  [27.2, -79.1],
];

export const maxBounds: number[][] | undefined = apisPL.includes(apiPrefix)
  ? maxBoundsPL
  : apisFL.includes(apiPrefix)
    ? maxBoundsFL
    : undefined;

//* SpeedUnit: kmh or mph
export const baseSpeedUnit: string = apisPL.includes(apiPrefix) ? "kmh" : apisFL.includes(apiPrefix) ? "mph" : "";

//# Api V2/V3 settings
//* Api TC2.0
const apiListTC2 = [
  "https://tcspk.iplaner.pl/api",
  "https://tcsc.tracktrolley.com/api",
  "https://tcdt.tracktrolley.com/api",
  "https://tcsw.tracktrolley.com/api",
  "https://tccomb.tracktrolley.com/api",
  "https://tcmdt.tracktrolley.com/api",
  "https://tcfll.tracktrolley.com/api",
  "https://tckombus.goeuropa.net/api",
  "https://tckombus.iplaner.pl/api",
  "https://tcsroda.iplaner.pl/api",
  "https://pks.goeuropa.net/api",
  "https://api-dyspozytor.pksonline.pl/api",
  "https://tcztmkombus.iplaner.pl/api",
  "http://goeuropa.net:8093/api",
  "https://tcms.tracktrolley.com/api",
  "https://tcpb.tracktrolley.com/api",
  "https://tcrokbus.iplaner.pl/api",
  "https://tcbct.tracktrolley.com/api",
  "https://tcbus.iplaner.pl/api",
  "https://transitclock2.goeuropa.net/api",
];
//* Api TC3.0
const apiListTC3 = ["https://transitclock.goeuropa.net/api"]; //- TC2.0/TC3.0
const useApiTCv2: boolean = apiListTC2.includes(apiPrefix) ? true : false; //+ old/new api (for stats charts!)
const useApiTCv3: boolean = apiListTC3.includes(apiPrefix) ? true : false; //+ TC3.0
// console.log({ useApiTCv2, useApiTCv3 });
export const apiVersionTC = useApiTCv3 ? "TC3.0" : useApiTCv2 ? "TC2.0" : "TC1.0";
export const testMode: boolean = false; //- testMode!

//^ Archived - don't use it
//^ 101_Swarzedz TC
//* Imports
// import logoSwarzedz from "./assets/logo/logoSwarzedz.png";
// import { treeGroupsDataSwarzedz } from "./data/swarzedzShifts";
// export const configAgencyName = "Swarzedz";
// //* Eksports
// export const logo = logoSwarzedz;
// export const treeGroupsData = treeGroupsDataSwarzedz;
// export const apiKey = "f78a2e9a";
// export const initialTableBigComponentColumns = [
//   "00_#",
//   "01_Zmiana",
//   "02_Linia",
//   "03_Zadanie",
//   "12_Pojazd",
//   "13_Status",
//   "14_Postęp",
//   "23_Akcje",
// ];
// //* Api prefix
// export const apiPrefix = "https://tcspk.iplaner.pl/api"; //- prod
// export const apiPrefixWeb = "https://tcspk.iplaner.pl"; //+ apiWeb
// //* Reverse GeoCoding
// export const reverseGeocodingPrefix = "https://nominatim.goeuropa.net";
// export const showReverseGeocoding = false; //! showReverseGeocoding
// // Name app
// export const appName = "KiedyBus TC";
// // Fetch interval
// export const fetchInterval = process.env.NODE_ENV === "development" ? 100 * 1000 : 15 * 1000; //+ fetchInterval
// // Bus toleration settings
// const tooFastToleration = 60 * 1 * 1000; //* [ms]
// const delayToleration = -60 * 3 * 1000; //* [ms]
// // Map setting
// export const zoomRange = 0.02;
// export const busZoom = 11.5;
// export const positionZoom = 18;
// export const positionAccuracy = 4;
// export const defaultTabKey = "grupa";
// //* Disable buttons and Header info
// export const disableButtons = false;
// export const disableSettingsButton = false;
// export const contentOnlyForTA = false;
// export const disableCancelReenableTripButton = true; //+ disableCancelReenableTripButton
// // TripsReport
// export const showFullTable = true;
// // Table width
// export const initialTableWidth = 4;
// // Fetching vehiclesToBlock
// export const useApiVehiclesToBlock = true; //- useApiVehiclesToBlock
// // vehiclesDetails
// export const useLongVehicleDetails = true;
// export const traccarApiKnotsToKmh = 1.0; //* ???
// // i18next settings
// export const defaultLanguage = "pl";
// export const showChangeLanguage = true;
// //* TA only!
// export const comparisonApisVar: string | string[] = "";
// //* Traccar Api!
// export const traccarCredentials = null;
// //* ServiceAlerts
// const alertsUrl = "";
// //* Other settings
// export const initiallySelectedDays = ["0", "1", "2", "3", "4", "5", "6"];
// export const startFromAccordion: boolean = false;
// export const getOccupancyData: boolean = false;   //* Data also in VehicleDetails
// export const downloadableStopsData: boolean = false; //* 30-day report for all stops
// export const targetFolderStopsDataOnHost = ""; //^ 30-day stops report target url
